import React from 'react';
import './ItemOption.css';
import {BrowserView, MobileView} from 'react-device-detect';


export class ItemOption extends React.Component {
    constructor(props) {
      super(props);
      this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
      this.props.showModal(this.props.category, this.props.name);
    }
    formatString(str) {
      if(str.length>80) {
        return str.substring(0,69) + '...';
      }
      else {
        return str;
      }
    }
    render() {
        return(
            <div onClick = {this.handleClick} className = "card">
              <div className = "content">
                  <h3> {this.props.name} </h3>
                  <p>
                    <BrowserView>{this.props.description}</BrowserView>
                    <MobileView> {this.props.description}</MobileView>
                  </p>
              </div>
          </div>
        );
    }

}